import { Layout } from '@glu/core';
import template from './tableHeaderLayout.hbs';

/**
 * Layout for standard table header.  Currently includes regions for filters,
 * badges, and aux controls but can easily be adapted for additional regions.
 */
export default Layout.extend({
  template,

  setFilters(view) {
    this.filtersView = view;
  },

  setFilterBadges(view) {
    this.filterBadgesView = view;
  },

  setFilterBadgeHeader(view) {
    this.filterBadgeHeaderView = view;
  },

  setPager(view) {
    this.pagerView = view;
  },

  setSavedViews(view) {
    this.savedViewsView = view;
  },

  setToggleButtons(view) {
    this.toggleButtonsView = view;
  },

  setMultiColumnSort(view) {
    this.multiColumnSortView = view;
  },

  onRender() {
    if (this.filtersView) {
      this.filters.show(this.filtersView);
    }

    if (this.filterBadgesView) {
      this.filterBadges.show(this.filterBadgeHeaderView);
    }

    if (this.pagerView) {
      this.pager.show(this.pagerView);
    }

    if (this.savedViewsView) {
      this.savedViews.show(this.savedViewsView);
    }

    if (this.toggleButtonsView) {
      this.toggleButtons.show(this.toggleButtonsView);
    }

    if (this.multiColumnSortView) {
      this.multiColumnSort.show(this.multiColumnSortView);
    }
  }
});
